var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { WeekItem } from './WeekItem';
var Container = styled.section.withConfig({ displayName: "Container", componentId: "sc-dyxhff" })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Delimiter = styled.div.withConfig({ displayName: "Delimiter", componentId: "sc-k3tcx4" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: linear-gradient(180deg, #e6f4f6 0%, rgba(254, 254, 254, 0) 305%);\n  height: 10px;\n"], ["\n  background: linear-gradient(180deg, #e6f4f6 0%, rgba(254, 254, 254, 0) 305%);\n  height: 10px;\n"])));
var List = styled.ul.withConfig({ displayName: "List", componentId: "sc-nlf8ap" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 16px;\n  justify-content: space-between;\n  margin: 0;\n  background: ", ";\n  padding: 8px 32px 24px 70px;\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 16px;\n  justify-content: space-between;\n  margin: 0;\n  background: ", ";\n  padding: 8px 32px 24px 70px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue99;
});
var Weeks = function (_a) {
    var data = _a.data, rest = __rest(_a, ["data"]);
    return (_jsxs(Container, __assign({}, rest, { children: [_jsx(Delimiter, {}, void 0), _jsx(List, { children: data.map(function (d) { return (_createElement(WeekItem, __assign({}, d, { position: d.position, key: d.position }))); }) }, void 0)] }), void 0));
};
export { Weeks };
var templateObject_1, templateObject_2, templateObject_3;
